import { render, staticRenderFns } from "./AddDomain.vue?vue&type=template&id=4c933ef1&scoped=true&"
import script from "./AddDomain.vue?vue&type=script&lang=js&"
export * from "./AddDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c933ef1",
  null
  
)

export default component.exports